import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { emailSignin } from '../../../api/auth';
import './SigninWithEmailView.css';
import TopBar from '../../common/TopBar/TopBar';
import AuthInput from '../../buttons/AuthInput';
import CTAButton from '../../buttons/CTAButton';
import AuthButton from '../../buttons/AuthButton';
import LoadingScreen from '../../common/LoadingScreen/LoadingScreen'; // Import LoadingScreen

const SigninWithEmailView: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const isEmailValid = email.trim().length > 0;
  const isPasswordValid = password.trim().length > 0;
  const isFormValid = isEmailValid && isPasswordValid;

  const handleSignIn = async () => {
    if (isFormValid) {
      setIsLoading(true);
      setError(null);
      try {
        const user = await emailSignin(email, password);
        console.log('Signed in user:', user);
        navigate('/playground'); // Adjust this route as needed
      } catch (error) {
        setError('Invalid email or password. Please try again.');
        console.error('Sign-in error:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot_password');
  };

  if (isLoading) {
    return <LoadingScreen />; // Show LoadingScreen while signing in
  }

  return (
    <div className="signin-email-view">
      <TopBar showBackButton={true} showLogo={true} />
      <h1 className="title">Welcome back</h1>
      <p className="subtitle">Sign in to your Vivid</p>
      <div className="input-container">
        <AuthInput
          type="text"
          placeholder="Write email or username"
          value={email}
          onChange={setEmail}
        />
        <AuthInput
          type="password"
          placeholder="Write password"
          value={password}
          onChange={setPassword}
        />
        {error && <p className="error-message">{error}</p>}
      </div>
      <CTAButton
        text="Sign in"
        onClick={handleSignIn}
        isActive={isFormValid}
      />
      {/* <p className="or-text">OR</p>
      <div className="auth-buttons">
        <AuthButton provider="Instagram" action="signin" onSignIn={() => {}} onSignUp={() => {}} />
        <AuthButton provider="Tiktok" action="signin" onSignIn={() => {}} onSignUp={() => {}} />
      </div> */}
      <p></p>
      <a href="/forgot_password" className="forgot-password" onClick={handleForgotPassword}>Forgot your password?</a>
    </div>
  );
};

export default SigninWithEmailView;